<!--
 * @Author: Soul
 * @Date: 2021-06-25 17:23:14
 * @LastEditors: 诺
 * @LastEditTime: 2022-10-31 21:12:34
 * @Description: file content
-->
<template>
  <div class="bg">
    <div class="bgImg"></div>
    <BaseImg :option="{style: {'margin-top':'14px','margin-left':'16px',width: '71px','align-self': 'flex-start'},url: 'logo.png',}"/>
    <BaseImg :option="{style: {'margin':'27px auto 0',width: '100%',},url: 'slogan.png',}"/>

    <BaseImg :option="{style: {'margin':'0 auto',width: '100%',zIndex:1},url: 'sign_bg_1.png',}"/>
    <div class="content-bg">
      <div class="t1">您已成功获得<span class="actives">1元抵1平米优惠</span></div>
      <div class="t1">当前已有<span class="actives2"> {{assistanceCount}} </span>人助力，再邀请<span class="actives2"> {{assistanceCount>=3?0:1}} </span>人</div>
      <div class="t1">即可<span class="actives">额外再</span>获得1000元房款立减券</div>
      <div class="t1"><span class="actives" style="color:RGBA(238, 93, 32, 1)">至多可再找人{{ max - assistanceCount > 0 ? (max - assistanceCount) : 0  }}助力，再省{{ (max - assistanceCount > 0 ? (max - assistanceCount) : 0) * 1000 }}元</span></div>
      <div class="t2">（本优惠券仅适用于认购之前出示）</div>
      <!-- <div class="t1">
        已有
        <span class="num">{{assistanceCount}}</span>
        人助力, 再邀请
        <span class="num">{{assistanceCount>=3?0:1}}</span>
        人
      </div>
      <div class="t2">即可额外获得1000元房款立减券</div>
      <div class="t3">（至多领取3张）</div> -->
    
      <div class="progress-wrap">
        
        <div class="progress-prize">
          <div class="redpack"></div>
          <div class="redpack" v-for="(item) in prizeInfo" :key="`red${item.externalId}`"><img class="red-img" :src="`${imgHost}coupon/red-pack.png?v=${$config.OSSVersion}`"/></div>
        </div>
        <div class="progress">
          <div class="bar" :style="{width:`${(assistanceCount > max ? max : assistanceCount) / max*100}%`}">
            <div class="dot"></div>
          </div>
        </div>
        <div class="progress-title">
          <!-- <div class="title1">开始助力</div> -->
          <div class="title2"></div>
          <div class="title2" v-for="(item,index) in prizeInfo" :key="`index${index}`">
            <div class="people">{{item.assistanceCount}}人</div>
            <div class="money">{{item.alias}}</div>
          </div>
        </div>
      </div>

      <div class="line"></div>
      <div class="avatar-list">
        <div class="item" v-for="(item,index) in friendList" :key="index">
            <div class="avatar-item">
              <img :src="item.headImg"/>
              <span>{{item.nickName}}</span>
            </div>
        </div>
      </div>
      <div class="sign_up" @click="goShare">
        邀请好友助力
      </div>
    </div>
      <BaseImg :option="{style: {'margin':'0 auto',width: '100%',},url: 'sign_bg_3.png',}"/>

    <img class="receive" @click="receive" :src="imgHost + 'coupon/receive.png?v=' + $config.OSSVersion" />
    <div class="btn_home" @click="goPage">
      <img :src="imgHost + 'goHome.png?v=' + $config.OSSVersion" />
    </div>
  </div>
</template>

<script>
import { MessageBox,  } from "mint-ui";
// import Vue from "vue/dist/vue.js";
// import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
  components: {
  },
  data() {
    return {
      friendList:[
        {headImg:`${this.$config.imgHost}coupon/avatar.png?v=${this.$config.OSSVersion}`,nickName:'待邀请'},
        {headImg:`${this.$config.imgHost}coupon/avatar.png?v=${this.$config.OSSVersion}`,nickName:'待邀请'},
        {headImg:`${this.$config.imgHost}coupon/avatar.png?v=${this.$config.OSSVersion}`,nickName:'待邀请'},
      ],
      prizeInfo:[],
      assistanceCount:0,
      max:3
    };
  },
  filters: {
    formatTime: function (value) {
      return value < 10 ? "0" + value : value;
    }
  },
  watch: {},
  computed:{
  },
  methods: {
    goPage(){
        this.$goPage('index')
    },
    async submit(){
      if (!this.canGet) {
        return
      }
      // if (this.$mobile || this.$util.cookie.get("mobile")) {
        const data = await this.$httpdf.get( this.apiHost + 'jdQuestion/lockProjectCoupon', {
          // name: this.$userInfo.nickName,
          prizeId: this.projectData.id,
          // addressId: this.addressId,
          // addressName: this.addressName,
        })
        if (data.code == 0) {
      //     Toast({
      //       message: "领取成功",
      //       duration: 2000,
      //     });
      //     this.showBtn = false
      //   } else {
      //     MessageBox.alert(data.msg);
      //   }
      // } else {
          this.$modal.drawForm.alert({ prizeId: this.projectData.id }).then(() => {
            this.getProjectCouponInfo()
          })
        } else {
          MessageBox.alert(data.msg);
        }
    },
    async getProjectCouponInfo() {
      let data = await this.$httpdf.get( this.apiHost + 'jdQuestion/getProjectCouponInfo', { projectId: this.projectId })
      this.projectData = data.data
      this.canGet = data.data?.inStock
      if (this.projectData) {
        data = await this.$httpdf.get( this.apiHost + 'order/isReceived', { prizeId: this.projectData?.id })
        this.showBtn = data.data ? false : true
        data = await this.$httpdf.get(this.apiHost + 'lucky/prize/getPrizeById', { prizeId: this.projectData?.id })
        this.addressId = data.data?.address[0]?.addressId
        this.addressName = data.data?.address[0]?.addressName
      }
    },
    async getAssistanceInfo() {
      const data = await this.$httpdf.get(this.apiHost + 'dongYuan/assistanceInfo')
      this.hasReceive = data.data?.received
      this.assistanceCount = data.data?.assistanceCount
      this.prizeInfo = data.data?.list
      // console.log(data)
    },
    async getMyFriends() {
      const data = await this.$httpdf.get(this.apiHost + 'dongYuan/myFriends')
      if (data.code == 0) {
        let  friendList = data.data.filter((v)=> v!=null)
        if(friendList.length<3){
          friendList=friendList.concat(this.friendList.splice(friendList.length,3))
        }else{
          friendList=friendList.splice(0,3)
        }
        this.friendList=friendList
      }
    },
    async receive(){
      const prizeList=this.prizeInfo
      let prizeInfo=null
      console.log(prizeList)
      prizeList.forEach(async (item)=>{
        if(item.reached==1&&item.received==0&&!prizeInfo){
          prizeInfo=item
        }
      })
      console.log(prizeInfo)
      let unReceived = prizeList.filter(item => item.received == 0)
      if(!unReceived.length){
        //没有未领取的,也就是都领取过,提示
        return MessageBox.alert("您已获取全部优惠！还可继续参与其他板块获取更多好礼哦！", "提示").then(() => {
          this.$goPage("index")
        })
      }
      if(!prizeInfo){
        this.goShare()
        return 
      }
      const {data} = await this.$httpdf.get(this.apiHost + 'prize/getPrizeById', { prizeId: prizeInfo.externalId })
      this.$modal.drawForm.alert({ 
        prizeInfo: data.prize,
        drawTxt: 2,
        prizeType:'couponFree',
        address:data.address,
        prizeId:prizeInfo.externalId }).then(()=>{
          this.getMyFriends()
          this.getAssistanceInfo()
        })
    },
  },
  async created() {
  },
  async mounted() {
    this.getMyFriends()
    this.getAssistanceInfo()
  },
};
</script>

<style lang="scss" scoped>
div{
  position: relative;
}
.bg {
  padding-bottom:60px;
  background: linear-gradient(0deg, #FCC229 0%, #FDD142 49%, #FDD94F 100%);
  .bgImg{
    position: absolute;
    z-index:0;
    width: 343px;
    background-image: url( $imgHost + 'bg.png?v=' + $OSSVersion);
    background-position: top center;
    background-size: 100% auto;
    border: 1px solid #231815;
    border-radius: 0px 0px 62px 0px;
    top:51px;
    bottom:40px;
  }
  .content-bg{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: url( $imgHost + 'sign_bg_2.png?v=' + $OSSVersion) 0 0 / 100% repeat;
    z-index:2;
    margin-top: -10px;
    .t1{
      // font-weight: Bold;
      font-family: SourceHanSansCN-Bold;
      font-size: 13px;
      margin-bottom: 8px;
      .actives{
        color: #DA6734;
        font-weight:bold;
      }
      .actives2{
        font-size: 15px;
        color: #DA6734;
        font-style: italic;
      }
      .num{
        color: #DA6734;
        font-size: 20px;
        font-family: SourceHanSansCN-Bold;
        font-weight: Bold;
      }
    }
    .t2{
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #DD9139;
      line-height: 20px;
    }
    .t3{
      font-size: 10px;
      color: #211718 ;
      line-height: 21px;
    }
  }

  .progress-wrap{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 277px;
    margin-top: 15px; 
    .progress-prize{
      width: 245px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .redpack{
        width: 36px;
        height: 36px;
        .red-img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .progress{
      width: 235px;
      height: 10px;
      background: #FEDAB0;
      border: 1px solid rgba(222, 150, 118, 1);
      border-radius: 5px;
      .bar{
        position: absolute;
        left:-1px;
        top:-1px;
        width: 69px;
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        background: #E5843B;
        border: 1px solid #DA6734;
        border-radius: 5px;
        .dot{
          width: 6px;
          height: 6px;
          background: #F79465;
          border: 1px solid #DA6734;
          border-radius: 50%;
        }
      }
    }
    .progress-title{
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 7px;
      .title1{
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #201715;
      }
      .title2{
        display: flex;
        flex-direction: column;
        align-items: center;
        flex:1;
        .people{
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #201715;
          margin-bottom: 6px;
        }
        .money{
          font-size: 10px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #DA6734;
          transform: scale(0.9);
        }
      }
    }
  }

  .line{
    width: 73.87%;
    height: 49px;
    background-image: url( $imgHost + 'coupon/line.png?v=' + $OSSVersion);
    background-position: top center;
    background-size: 100% auto;
    background-repeat: no-repeat;
    margin-top: 10px;
  }
  .avatar-list{
    margin:6px 98px 0;
    width:179px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item{
      display: flex;
      align-items: center;
      .avatar-item{
        position: relative;
        text-align: center;
        width:36px;
        img{
          margin: 4px 0;
          border-radius: 20px;
        }
        span{
          display:block;
          width:36px;
          text-align: center;
          color: #DA6734;
          line-height: 20px;
          font-size:10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .arrow{
        position: relative;
        width:17px;
        margin:0 6px ;
        margin-bottom: 20px;
      }
    }
  }
  .sign_up{
    width:262px;
    height:62px;
    line-height: 58px;
    text-align: center;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #201715;
    letter-spacing: 7px;
    padding-left:10px;
    margin-top:10px;
    background: url( $imgHost + 'btn_bg.png?v=' + $OSSVersion) 0 0 / 100% repeat;
  }
  .receive{
    margin-top:17px;
    width:205px;
    z-index:2;
  }
}
.btn_home {
  width: $backWidth;
  position: fixed;
  bottom: 60px;
  right: 0;
  z-index: 90;
}
</style>
